import * as React from "react";
import { Button } from "@/components/ui/button";
import { Notify } from "@/components/ui/notify";

interface LinesEmptyStateProps {
  totalLines: number;
  isGestor: boolean;
  onCreate: () => void;
}

export function LinesEmptyState({
  totalLines,
  isGestor,
  onCreate,
}: LinesEmptyStateProps): React.ReactElement {
  const hasAnyLine = totalLines > 0;
  return (
    <Notify.Empty
      title={hasAnyLine ? "Sem resultados" : "Nenhuma linha cadastrada"}
      description={
        hasAnyLine
          ? "Ajuste os filtros para ver linhas."
          : isGestor
            ? "Comece criando sua primeira linha."
            : "Solicite a um gestor."
      }
      action={
        isGestor && !hasAnyLine ? (
          <Button size="sm" onClick={onCreate}>
            Criar primeira linha
          </Button>
        ) : null
      }
    />
  );
}
